import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const PowerballEvo = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="EVOPowerball"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default PowerballEvo;


// WEBPACK FOOTER //
// ./src/containers/minigame/PowerballEvo.js